var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template"},[_c('header',{staticClass:"template__header"},[_c('div',{staticClass:"header__icon custom-icon mr10 cursor-default",class:_vm.articleIcon}),_c('span',{staticClass:"header__title",attrs:{"id":_vm.titleId}},[_vm._v(_vm._s(_vm.title))])]),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }